/**
 * Namespaces the homepage feed/sidebar touch. AppLoading awaits these before
 * revealing home-feed paths (a namespace missing after first paint re-suspends
 * AppContent), and `translation-provider.tsx` derives its preload list from this
 * one so the two can't drift. `admin` (~100KB) is deliberately excluded — its only
 * homepage consumer loads it on intent when the invite modal opens.
 */
export const HOME_FEED_NAMESPACES = [
	'action_input',
	'announcements',
	'awards',
	'bookmarks',
	'celebrations',
	'common',
	'components', // promo modals mounted unconditionally in HomepageContent
	'feedback', // PendingFeedbackRequestsAlert
	'incentives',
	'navigation',
	'nominations', // VotingActiveBanner
	'onboarding', // ReviewSolicitationsModal (mounts above AppContent's boundary)
	'recognition',
	'spotlight',
	'tracker_widget',
	'video',
] as const;
